import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import Tabs, { TabsProps } from './Tabs';
import { DataStore, AccessibilityStore, SuperscriptScope } from '../stores';
import { camelCase } from '@kurtosys/ksys-app-template/dist/utils/changeCase';
import { ConditionalDisclaimers } from '../models/configuration/disclaimers/ConditionalDisclaimers';
import TabRegion from '../models/components/TabRegion';
import { Theme } from '../models/Theme';

interface ModuleTabsProps {
    theme?: Theme;
    dataStore?: DataStore;
    accessibilityStore?: AccessibilityStore;
    ConditionalDisclaimers?: ConditionalDisclaimers;
}

@inject('dataStore', 'accessibilityStore')
@observer
class ModuleTabs extends React.Component<ModuleTabsProps> {
    get tabsProps(): TabsProps {
        const { dataStore, theme } = this.props;
        return {
            region: TabRegion.Module,
            tabs: dataStore.config.modules.map(module => {
                return {
                    id: module.id,
                    label: module.label,
                    disclaimers: module.disclaimers,
                };
            }),
            setTabActive: tab => {
                dataStore.logDataLayer('tab_navigation', {
                    tabRegion: TabRegion.Module,
                    tabLabel: tab.label,
                });
                dataStore.config.setModule(tab);
            },
            isTabSelected: tabId =>
                tabId === dataStore.config.selectedModule.id,
            getMetricContext: tab => `moduleTabs-${camelCase(tab.label)}`,
            tabThemeOverride: theme.ModuleTab,
        };
    }

    render() {
        const { theme, accessibilityStore } = this.props;
        return (
            <Tabs
                {...this.tabsProps}
                marginY="lg"
                {...theme.ModuleTabs}
                aria-label={accessibilityStore.modulesLandmark}
                superscriptScope={SuperscriptScope.module}
            />
        );
    }
}

export default withTheme(ModuleTabs);



// WEBPACK FOOTER //
// ./src/Components/ModuleTabs.tsx